module.exports = __webpack_public_path__ + "img/920.0f8fe1f0.png";